import React, { createContext, useState } from "react";

export const SearchUserContext = createContext({});

const SearchUserProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState({
    username: "",
    fullName: "",
    estateId: "",
    lineOfWorkId: "",
  });
  const [pageValues, setPageValues] = useState({
    page: 0,
    pageSize: 10,
    total: 0,
    totalPage: 0,
    sortBy: "userId",
    sortDirection: "ASC",
  });

  return (
    <SearchUserContext.Provider
      value={{ searchValues, setSearchValues, pageValues, setPageValues }}
    >
      {children}
    </SearchUserContext.Provider>
  );
};

export default SearchUserProvider;
